import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Refs from './views/Refs.vue';
import RefPage from "./views/RefPage.vue";
import Cupons from "./views/Cupons.vue";
import CuponPage from "./views/CuponPage.vue";
import StatsPage from './views/StatsPage.vue';

Vue.use(Router);

export default new Router({
  routes: [{
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/refs',
      name: 'refs',
      component: Refs,
    },
    {
      path: '/ref/:id',
      name: 'ref',
      component: RefPage,
    },
    {
      path: '/cupons',
      name: 'cupons',
      component: Cupons,
    },
    {
      path: '/cupon/:id',
      name: 'cupon',
      component: CuponPage,
    },
    {
      path: '/stats',
      name: 'stats',
      component: StatsPage
    }
  ],
});
